enum PoliceDepartment {
  DriverHouse = 1,
  AutomovileCenter = 2,
  Digesset = 0,
}
export default PoliceDepartment;
